import { UserFolders, UserProfile } from '@/types/api'

export function validateFolders(folders: any): UserFolders {
  // update to new format and fix circular dependencies
  let changed = false
  const result: UserFolders = {}

  const mfp = [0]
  const mfs = [1]

  function mf_find(x: number) {
    let p = mfp[x]
    while (p !== x) {
      const gp = (mfp[x] = mfp[p])
      x = p
      p = gp
    }
    return x
  }
  function mf_merge(x: number, y: number) {
    x = mf_find(x)
    y = mf_find(y)
    if (x === y) return
    const xs = mfs[x],
      ys = mfs[y]
    if (xs < ys) {
      mfp[x] = y
      mfs[y] += xs
    } else {
      mfp[y] = x
      mfs[x] += ys
    }
  }

  for (const id in folders) {
    const numeric = parseInt(id)
    if (!folders[id] || isNaN(numeric)) {
      // blank or broken entry, remove
      changed = true
      continue
    }
    let parent = 0
    if (typeof folders[id] !== 'object') {
      // old format, update
      changed = true
      result[numeric] = { name: folders[id], parent }
    } else {
      parent = parseInt(folders[id].parent)
      if (isNaN(parent)) {
        changed = true
        parent = 0
        result[numeric] = { name: folders[id].name, parent }
      } else {
        result[numeric] = folders[id]
      }
    }
    mfp[numeric] = numeric
    mfs[numeric] = 1
  }

  for (const id in result) {
    mf_merge(parseInt(id), result[id].parent)
  }

  const root = mf_find(0)
  for (const id in result) {
    const group = mf_find(parseInt(id))
    if (group !== root) {
      changed = true
      result[id].parent = 0
    }
  }

  // we have to return the original object if no issues were detected
  return changed ? result : folders
}

export function folderIsChild(
  folders: UserFolders,
  id: number,
  parent: number
) {
  for (let cur = id; cur; cur = folders[cur].parent) {
    if (cur === parent) {
      return true
    }
  }
  return false
}

export function folderSetParent(
  folders: UserFolders,
  id: number,
  parent: number
) {
  if (folders[id].parent === parent || folderIsChild(folders, parent, id)) {
    return folders
  }
  folders = { ...folders }
  folders[id] = { ...folders[id], parent }
  return folders
}

export function folderRename(folders: UserFolders, id: number, name: string) {
  if (!name || folders[id].name === name) return folders
  folders = { ...folders }
  folders[id] = { ...folders[id], name }
  return folders
}

export function folderDelete(folders: UserFolders, id: number) {
  folders = { ...folders }
  const parent = folders[id].parent
  for (const other in folders) {
    if (folders[other].parent === id) {
      folders[other] = { ...folders[other], parent }
    }
  }
  delete folders[id]
  return folders
}

export function profileUpdate(profiles: UserProfile[], value: UserProfile) {
  const index = profiles?.findIndex((profile) => profile.id === value.id)
  if (!profiles || index < 0) return profiles
  profiles = profiles.slice()
  profiles[index] = value
  return profiles
}

export function profileDelete(profiles: UserProfile[], id: string) {
  const index = profiles?.findIndex((profile) => profile.id === id)
  if (!profiles || index < 0) return profiles
  profiles = profiles.slice()
  profiles.splice(index, 1)
  return profiles
}

export function profileRename(
  profiles: UserProfile[],
  id: string,
  name: string
) {
  const index = profiles?.findIndex((profile) => profile.id === id)
  if (!profiles || index < 0 || profiles[index].name === name) return profiles
  profiles = profiles.slice()
  profiles[index] = { ...profiles[index], name }
  return profiles
}

export function profileMove(
  profiles: UserProfile[],
  id: string,
  folder: number
) {
  const index = profiles?.findIndex((profile: any) => profile.id === id)
  if (!profiles || index < 0) return profiles
  profiles = profiles.slice()
  profiles[index] = { ...profiles[index], folder }
  return profiles
}

export function profilesAdd(profiles: UserProfile[], profile: UserProfile) {
  if (!profiles) return profiles

  profiles = profiles.slice()
  const index = profiles.findIndex((p) => p.id === profile.id)
  if (index >= 0) {
    profiles[index] = profile
  } else {
    profiles.push(profile)
  }
  return profiles
}
